import { formatAmount, milliToDate, dateFormatter } from "../../../../utils/commonUtil";
import { Table } from "antd";
import { addressFormat } from "../RecommendGrant/utils";

export const prepareRender = props => {
  const {
    contact,
    purpose,
    startDate,
    grantAgreementAmount,
    noOfPayments
  } = props;

  const charityInfo = {
    title: "Charity Information",
    charityName: contact.legalName,
    charityAddress: gaAddressFormatter({...contact}),
    charityEin: contact.ein,
    edit: false
  };

  const purposeRecognition = createPurposeRecogRender(props);
  const amountAllocation = createScheduleRender(props);

  return {
    charityName: contact.legalName,
    grantAmount: grantAgreementAmount,
    publishName: purpose.publishName,
    frequency: null,
    startDate: startDate,
    noOfPayments: null,
    scheduleType: null,
    charityInfo,
    purposeRecognition,
    amountAllocation,
    scheduleData: {
      frequency: null,
      noOfPayments: noOfPayments,
      startDate,
      grantName: contact.legalName,
      Table
    }
  };
};

export const createPurposeRecogRender = props => {
  const { purpose, recognition, advisors } = props;
  let notifyName;
  if (recognition.notifyFirstName && recognition.notifyLastName) {
    notifyName = `${recognition.notifyFirstName} ${recognition.notifyLastName}`;
  }
  return {
    title: "Grant Purpose & Recognition",
    purposeName: purpose.description,
    additionalComments: purpose.additionalComments,
    inHonorOfName:
      recognition.inHonorOfName && `In honor of ${recognition.inHonorOfName}`,
    inMemoryOfName:
      recognition.inMemoryOfName &&
      `In memory of ${recognition.inMemoryOfName}`,
    recognition,
    notifyName,
    advisors,
    grantRecognition: recognition.grantRecognition,
    includeAdvisorInfo: !(purpose.otherIndDoNotIncAcctAdv === "on"),
    thirdParty: recognition.thankIndividualName,
    accountName: recognition.accountName,
    edit: false
  };
};

const gaAddressFormatter = ({
  addressLine1,
  addressLine2,
  addressLine3,
  state,
  city,
  zip
}) => ({
  addressLine1: addressLine1,
  addressLine2: addressLine2,
  addressLine3: addressLine3,
  state: state,
  city: city,
  zipCode: zip
});

export const createScheduleRender = props => {
  const {
    grantAgreementAmount,
    startDate,
    noOfPayments,
    endDate,
    investments,
    investmentType,
    invalidAllocation = true
  } = props;
  const allocation = investmentType && investmentType.toLocaleLowerCase().trim(' ');

  const typeContentMap = (type) => {
    switch(type) {
      case "by weighted dollar": 
      return "weightedAllocations"
      case "by specified dollar": 
      return "byDollars"
      case "by specified percent": 
      return "byPercentage"
      default:
        return false
    }
  }

  let amountString = `${formatAmount(grantAgreementAmount)}`;
  const totalAmount =
    parseInt(grantAgreementAmount, 10);
  amountString = `${noOfPayments} for a total of ${formatAmount(totalAmount)}`;
  let allocations = investments && investments.reduce((generated, pool, index) => {
    let temp = {};
    temp.name = pool.investionOption;
    temp.grantAmount = pool.amount;
    temp.grantPercentage = pool.percentage;
    temp.id = ++index;
    generated.push(temp);
    return generated;
  }, []);
  const formattedAllocations = allocations.filter(item => {
    if(item.grantAmount > 0) return item;
  });

  return {
    title: "Recommended amount & allocation",
    paymentType: "Recurring Payment",
    amountString,
    grantAgreement: true,
    recurring: true,
    grantAgreementAmount: grantAgreementAmount,
    startDate: dateFormatter(startDate),
    endDate: dateFormatter(endDate),
    allocationType: allocation && typeContentMap(allocation.toLocaleLowerCase()),
    allocations: invalidAllocation ? allocations : formattedAllocations
  };
};


const typeMap = {
  weightedAllocations: "By weighted percentage",
  byDollars: "By specific dollar amount",
  byPercentage: "By specific percentage",
};

export const reverseMapAllocationType = allocationPreference => {
  let allocationType;
  for (let type in typeMap) {
    if (typeMap[type].toUpperCase() === allocationPreference.toUpperCase()) {
      allocationType = type;
    }
  }
  return allocationType;
};
